import React from "react";
import ReactDOM from "react-dom";
import singleSpaReact from "single-spa-react";
import Root from "./root.component";

// Exportar utilidades de idioma
export {
  currentLanguage$,
  isLocalStorageEnabled,
  getInitialLanguage,
  getLanguageFromUrl,
  changeLanguage,
  initLanguageService,
  handleLanguageParam,
  initializeLanguage
} from "./utils/language-utils";

// Exportar utilidades de chat
export * from "./utils/chat-utils";

// Exportar configuración de chat
export {
  CHAT_PHONES,
  CHATCENTER_AVAILABLE_COUNTRIES_ID,
  PRE_SALES_AVAILABLE_COUNTRIES,
  APPS_NOT_ALLOWED,
} from "./config/chat";

// Exportar servicios principales
export * from "./services/geolocationService";
export * from "./services/paymentService";
export * from "./services/promoService";
export * from "./services/countriesService";
export * from "./services/breakpointService";
export * from "./services/navigationService";
export * from "./services/quoteService";

// Exportar servicio de idiomas
export * from "./services/languageService";
// Exportar hooks de utilidades
export * from "./utils/breakpoint-hooks";
// Exportar hooks de navegación
export * from "./hooks/useNavigation";
// Exportar contextos compartidos (tienen prioridad sobre utils antiguos)
export * from "./contexts";

export { useBanners } from "./hooks/useBanners";

// Funciones específicas exportadas individualmente para claridad
export { getCountries } from "./services/countriesService";
export { getQuoteRegions, getRegionById, getRegionByName } from "./services/quoteService";

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: Root,
  errorBoundary(err, info, props) {
    return null;
  },
});

export const { bootstrap, mount, unmount } = lifecycles;